import React from 'react';

import { Grid, Typography, Paper } from '@material-ui/core';
import { Description as DescriptionIcon } from '@material-ui/icons';

import { CheckField, Step } from '../SteppedForm';

const StepTermsandconds = (props) => {
  return (
    <Step id="termsandconds" title="Terms and conditions" skip={false}>
      <Grid container justify="center" alignItems="center" spacing={1}>
        <Grid item xs={12}>
          <Paper style={{ margin: '0.4vw' }} elevation={0}>
            <Typography variant="h6" align="left">
              Data Collection Statement
            </Typography>
            <Typography variant="p" align="left" paragraph>
            </Typography>
            <Grid>
              <Typography variant="body1" align="left" paragraph={true}>
              In order to assess your application, 
               provide our products and services and otherwise conduct our business functions and activities, we need to collect your personal information
              </Typography>

              <Typography variant="body1" align="left" paragraph={true}>
                By providing your personal information to us, you agree that it will be used and disclosed
                by 13cabs including its related entities (collectively referred to as we, us or our)
                in accordance with this statement and our
                <a href="https://www.13cabs.com.au/privacy-policy/"> Privacy Policy</a>
              </Typography>

              <Typography variant="body1" align="left" paragraph={true}>
                We may disclose your personal information to our related entities and to other
                parties, including to third parties who provide products and services to us or
                through us in the ordinary operation, administration or promotion of our business
                and otherwise in accordance with our
                <a href="https://www.13cabs.com.au/privacy-policy/"> Privacy Policy</a>. 
                We may also disclose your personal information to third parties for the purposes 
                of conducting background checks including, without limitation, financial credit 
                and criminal history checks. By providing your consent below, you also hereby 
                consent to these third parties using your information to assist us in assessing your application. 
                From time to time,
                these third parties may be located (and therefore your personal information may be
                disclosed) overseas.
              </Typography>

              <Typography variant="body1" align="left" paragraph={true}>
                We may use and disclose your personal information for direct marketing purposes,
                unless you opt out (which you can do at any time in accordance with our{' '}
                <a href="https://www.13cabs.com.au/privacy-policy/"> Privacy Policy</a>
                ).
              </Typography>

              <Typography variant="body1" align="left" paragraph={true}>
                Our <a href="https://www.13cabs.com.au/privacy-policy/"> Privacy Policy</a> contains
                information about how you may access and seek correction of your personal
                information, how you may complain about a breach of your privacy, and how we will
                deal with that complaint.
              </Typography>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Paper
            style={{ margin: '0.5rem 0 2rem 0', cursor: 'pointer' }}
            onClick={() => window.open('https://www.13cabs.com.au/terms-conditions/', '_blank')}
            elevation={0}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <DescriptionIcon fontSize="large" style={{ color: '#1a76d9' }} />
              </Grid>
              <Grid item xs={11}>
                <Typography variant="h6">Terms and conditions</Typography>
                <Typography variant="p">
                  This defines the rights and responsibilities of our domain and web services that
                  we provide.
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Paper
            style={{ margin: '0.5rem 0 2rem 0', cursor: 'pointer' }}
            onClick={() => window.open('https://www.13cabs.com.au/privacy-policy/', '_blank')}
            elevation={0}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <DescriptionIcon fontSize="large" style={{ color: '#1a76d9' }} />
              </Grid>
              <Grid item xs={11}>
                <Typography variant="h6">Privacy Policy</Typography>
                <Typography variant="p">
                  This explains how we collect and use your information and your privacy with us.
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item>
          <CheckField
            id="policyCheck"
            label={`I have read and agree to be bound by the terms of this Data Collection Statement, the Privacy Policy and the Terms and Conditions.`}
            valid={(v) =>
              v
                ? true
                : 'You must agree to the terms and conditions of this service before you can continue'
            }
          />
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepTermsandconds;
